import { alpha, Box, Dialog, Typography } from "@mui/material";
import { type FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ALPHA, INK_BLACK } from "../../theme/tokens";
import { CheckMark } from "../UIToolkit/Animations/Checkmark";

// Time the success overlay stays on screen before auto-dismissing.
// Long enough to let the user read both lines, short enough not to block the UI.
const AUTO_DISMISS_MS = 2_000;

type Props = {
	open: boolean;
	onClose: () => void;
};

export const PickShiftSuccessOverlay: FC<Props> = ({ open, onClose }) => {
	const { t } = useTranslation();

	useEffect(() => {
		if (!open) return;
		const timerId = window.setTimeout(onClose, AUTO_DISMISS_MS);
		return () => window.clearTimeout(timerId);
	}, [open, onClose]);

	return (
		<Dialog
			data-testid="pick-shift-success-overlay"
			open={open}
			onClick={onClose}
			onClose={onClose}
			maxWidth="xs"
			slotProps={{
				paper: {
					sx: {
						borderRadius: 3,
						px: 3,
						py: 4,
						alignItems: "center",
						textAlign: "center",
						gap: 1.5,
						display: "flex",
						flexDirection: "column",
					},
				},
				backdrop: {
					sx: { backgroundColor: alpha(INK_BLACK, ALPHA.BACKDROP) },
				},
			}}
		>
			<Box sx={{ display: "flex", justifyContent: "center" }}>
				<CheckMark />
			</Box>
			<Typography variant="h6" sx={{ fontWeight: 700, color: "primary.dark" }}>
				{t("pickup.request.submitted.title")}
			</Typography>
			<Typography variant="body2" sx={{ color: "text.secondary" }}>
				{t("pickup.request.submitted.caption")}
			</Typography>
		</Dialog>
	);
};
